
import EditCategory from 'layouts/category/EditCategory.js';
import ManageCategories from 'layouts/category/ManageCategories.js';
import ProtectedRoute from "routes/protectedRoutes.js";
const CategoryRoutes = [


  {
    route: "productCategory/edit/:id/:type",
    key: "PoductcategoryEdit",
    component: <ProtectedRoute check="logout"><EditCategory  props={{'type':1}}/></ProtectedRoute>
  },
  {
    route: "serviceCategory/edit/:id/:type",
    key: "PoductcategoryEdit",
    component: <ProtectedRoute check="logout"><EditCategory  props={{'type':1}}/></ProtectedRoute>
  },

  {
    route: "productCategory/list/:pid",
    key: "Category-List-With-Parents",
    component: <ProtectedRoute check="logout"><ManageCategories  props={{'type':1}}/></ProtectedRoute>
  },
  {
    route: "serviceCategory/list/:pid",
    key: "Category-List-With-Parents",
    component: <ProtectedRoute check="logout"><ManageCategories  props={{'type':2}}/></ProtectedRoute>
  }




  ];

export default CategoryRoutes;
 